module.exports = __webpack_public_path__ + "assets/f831a0323fb5cadfdb2465f19db8709a.png";